import { useLanguageStore } from '@/pinia/language'

export const useLanguage = () => {
  const route = useRoute()
  const language = useLanguageStore()

  const queryLanguage = computed(() => route.query.lg?.toLowerCase())

  watch(queryLanguage, (val) => {
    if (val) {
      if (language.list.length === 0) {
        language.update(val)
        return
      }
      const isValidLanguage = language.list.find(item => item.language === val)
      if (isValidLanguage) {
        language.update(val)
      }
    }
  }, {
    immediate: true
  })

  return {
    initLanguage: language.init
  }
}
